<template>
	<div class="content">
		<div class="content-heading h5">RISK PROFILER</div>
		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<ul class="fa-ul">
					<li v-for="(question,q_index) in questions">
						<div v-if="form.answers[q_index].is_next==1">
							<p class="fw-semibold ps-1"><i class="badge rounded-pill bg-secondary fa-li ps-1">{{q_index+1}}</i> {{question.question}}</p>
							<div v-for="(choice,c_index) in question.choices" class="form-check form-block mb-3">
								<input @change="selectChoice(q_index,c_index)" type="radio" :id="'choice-'+q_index+'-'+c_index" name="answer" class="form-check-input" :value="choice.value"/>
								<label class="form-check-label" :for="'choice-'+q_index+'-'+c_index">
		                        	{{choice.choice}}
		                      	</label>
		                  	</div>
	                  	</div>
	              	</li>
				</ul>
			</div>
			<div class="block-content block-content-full text-end">
				<button v-if="cur_question.value>0" @click="nextQuestion()" type="button" class="btn btn-success" :disabled="form.processing">
					<i v-if="!form.processing" class="fa fa-arrow-right me-1"></i>
					<div v-else class="spinner-border spinner-border-sm text-white me-1" role="status" >
						<span class="sr-only mr-1">Loading...</span>
					</div>
					Next
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', window.gtag_id);

	import { useForm } from '@inertiajs/inertia-vue3';
	import { onMounted, watch, ref, reactive } from 'vue';
	import AuthLayout from '../../../Layouts/AuthLayout';
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: AuthLayout,
		props:{
			memberInfo 	: Object,
			questions 	: Object,
			flash 		: Object,
			errors 		: Object,
		},
		mounted(){

		},
		setup(props,context){

			const form = useForm({
				answers:[
					{
						is_next: 1,
						choice :'',
						value  : 0,
					},
					{
						is_next: 0,
						choice :'',
						value  : 0,
					},
					{
						is_next: 0,
						choice :'',
						value  : 0,
					},
					{
						is_next: 0,
						choice :'',
						value  : 0,
					},
					{
						is_next: 0,
						choice :'',
						value  : 0,
					},
					{
						is_next: 0,
						choice :'',
						value  : 0,
					},
					{
						is_next: 0,
						choice :'',
						value  : 0,
					},
					{
						is_next: 0,
						choice :'',
						value  : 0,
					},
					{
						is_next: 0,
						choice :'',
						value  : 0,
					},
				]
			});

			const cur_question = reactive({
				qno 	: 0,
				choice 	: '',
				value 	: 0,
			});

			const selectChoice = (q_index,c_index)=>{
				cur_question.choice 	= props.questions[q_index].choices[c_index].choice;
				cur_question.value 		= props.questions[q_index].choices[c_index].value;
			}

			const nextQuestion = ()=>{

				form.answers[cur_question.qno].choice 	= cur_question.choice;
				form.answers[cur_question.qno].value 	= cur_question.value;

				let is_last = false;

				for (var i = 0; i < form.answers.length; i++) {
					let answer = form.answers[i];
					let cur_i = 0;
					let new_question = {};

					if(parseInt(answer.value)>0)
					{
						form.answers[i].is_next = 0;

						if(form.answers.length>(i+1))
						{
							cur_i = i + 1;
							form.answers[cur_i].is_next 	= 1;
						}else{
							cur_i = i;
							form.answers[cur_i].is_next 	= 1;
							is_last = true;
						}

						new_question = {
							qno 	: cur_i,
							choice 	: form.answers[cur_i].choice,
							value 	: form.answers[cur_i].value,
						};

						Object.assign(cur_question,new_question);
						
					}

				}

				if(is_last){
					submitRisk();
				}
			}

			const submitRisk = ()=>{

				form.put('/member/investment/risk/'+props.memberInfo.member_uuid,{
					preserveState: true,
					preserveScroll: true,
					only:['errors','flash','memberInfo','questions'],
					onSuccess: (res)=>{

					}
				})
			}

			return {
				form,
				cur_question,
				selectChoice,
				nextQuestion,
				submitRisk,
			}
		}
	}
</script>